export default [
  {
    path: 'submissions',
    name: 'submissions.index',
    component: () => import('../Index.vue'),
    meta: {
      title: 'Submissions',
      description: 'Overview of the app.',
      sort: 0,
      authenticatable: false,
      icon: 'submissions',
    },
  },
]
